<template>
  <div class="card-body form-gorup-last">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">First Name</p>
          <p class="form-control-plaintext minimal">{{ user.first_name }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Last Name</p>
          <p class="form-control-plaintext minimal">{{ user.last_name }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">GEN Number</p>
          <p class="form-control-plaintext minimal">{{ user.gen | nullable }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Program</p>
          <p class="form-control-plaintext minimal">{{ graduate.program.name }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="control-label">Phone</label>
          <input type="text" v-model="statePhone" v-validate="" name="phone" class="form-control" />
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6"></div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Backup Email Address</p>
          <p class="form-control-plaintext">{{ user.email }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <p class="control-label">Username</p>
          <p class="form-control-plaintext">{{ user.username }}</p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-12 text-right">
        <div class="form-group">
          <ladda-button :click="handleSaveChanges" :validate="true" class="btn btn-success">Save Changes</ladda-button>
        </div><!-- /.form-group -->
      </div>
    </div><!-- /.row -->
  </div>
</template>

<script>
import { userComputed, userMethods, graduateComputed, graduateMethods } from 'vx/helpers'
import { stateMapper } from 'mixins/users'
import { pick } from 'lodash'
import { handleServerErrors } from 'utils'

export default {
  mixins: [stateMapper],

  computed: {
    ...userComputed,
    ...graduateComputed
  },

  async created () {
    await this.getGraduate(this.$user.id)
  },

  methods: {
    ...userMethods,
    ...graduateMethods,

    async handleSaveChanges () {
      let payload = pick(this.user, [
        'phone'
      ])
      try {
        await this.updateAccount(payload)
        this.$noty.success('Account details updated.')
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    }
  }
}
</script>
